import TemplateView from '../../../../../js/TemplateView'
import FeedNameCell from './cells/FeedNameCell'
import FeedDetailsCell from './cells/FeedDetailsCell'
import FeedUserSelection from './cells/FeedUserSelection'
import FeedActionsCell from './cells/FeedActionsCell'
import FeedLastSyncCell from './cells/FeedLastSyncCell'
import {getDeleteDialog} from '../../dialogs/DeleteDialog'
import {getRegenerateDialog} from '../../dialogs/RegenerateLinksDialog'

export default class AllFeedsRow extends TemplateView {
    constructor({
        feed,
        onEditClick,
    }) {
        super()

        this.params = {
            id: feed.id
        }

        this.state = {
            name: feed.name,
            createdDate: feed.createdDate,
            creator: feed.creator,
            editedDate: feed.editedDate,
            editor: feed.editor,
            leaveTypes: feed.leaveTypes,
            usersSelection: feed.usersSelection,
            sharedUsersSelection: feed.sharedUsersSelection,
            lastSyncDate: feed.lastSyncDate,
            recentlyConfiguredFeed: false,
        }

        this.callbacks = {
            onEditClick,
        }

        this.onStateDeeplyChanged(() => {
            this.getEl().empty()
            this._update()
        })
    }

    templateHtml() {
        return `<div class='feedRow allFeeds'/>`
    }

    _update() {
        this.getEl().toggleClass('recentlyConfiguredFeed', this.state.recentlyConfiguredFeed)

        new FeedNameCell({
            name: this.state.name,
            createdDate: this.state.createdDate,
            creator: this.state.creator,
            editedDate: this.state.editedDate,
            editor: this.state.editor,
            onNameClick: () => this.callbacks.onEditClick(this.params.id),
        }).init(this.getEl())

        new FeedDetailsCell({
            leaveTypes: this.state.leaveTypes,
            userSelection: this.state.userSelection,
        }).init(this.getEl())

        new FeedUserSelection({
                extraClass: 'sharedWithCell',
                userSelection: this.state.sharedUserSelection,
                shared: true,
            }
        ).init(this.getEl())

        new FeedLastSyncCell({
            lastSyncDate: this.state.lastSyncDate,
        }).init(this.getEl())

        this.regenerateDialog = getRegenerateDialog()
        this.deleteDialog = getDeleteDialog()
        this.feedActionsCell = new FeedActionsCell({
            onRegenerateClick: ($targetEl) => {
                this.regenerateDialog.setState({
                    iCalSettingsId: this.params.id,
                })
                this.regenerateDialog.showAt($targetEl, () => this.feedActionsCell.setState({regenerateActive: false}))
                this.feedActionsCell.setState({regenerateActive: true})
            },
            onDeleteClick: ($targetEl) => {
                this.deleteDialog.setState({
                    iCalSettingsId: this.params.id,
                })
                this.deleteDialog.showAt($targetEl, () => this.feedActionsCell.setState({deleteActive: false}))
                this.feedActionsCell.setState({deleteActive: true})
            },
        }).init(this.getEl())
    }
}



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/components/table/AllFeedsRow.js